import React from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';

const HouseholdMemberListItem = ({
  onClick,
  disabled,
  icon,
  primaryText,
  actionIcon,
  secondaryText,
  dense = true,
}) => {
  const secondaryProps = secondaryText
    ? {
        secondary: secondaryText,
        secondaryTypographyProps: {
          // NOTE: this needs to be text.secondary. Needs to be added to the component-library
          color: '#b4b4b4 !important',
        },
      }
    : {};

  return (
    <ListItem dense={dense}>
      <ListItemButton dense={dense} onClick={onClick} disabled={disabled}>
        <ListItemAvatar>{icon}</ListItemAvatar>
        <ListItemText primary={primaryText} {...secondaryProps} />
        <ListItemSecondaryAction>{actionIcon}</ListItemSecondaryAction>
      </ListItemButton>
    </ListItem>
  );
};

export default HouseholdMemberListItem;
